// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Vo-z","badgeLink":"Wo-z","category":"Xo-z"};